
import React from 'react';
import { 
  Calendar, Clock, DollarSign, Award, Target, 
  RefreshCw, BarChart, Users, MessageCircle, Palette 
} from 'lucide-react';

const ComparisonTable = () => {
  const comparisonData = [
    {
      aspect: 'Posts Per Month',
      others: '7–10',
      us: '60+ images & 30+ videos (daily!)',
      icon: <Calendar className="h-5 w-5" />
    },
    {
      aspect: 'Cost',
      others: '$1299+',
      us: '$249/month all-inclusive',
      icon: <DollarSign className="h-5 w-5" />
    },
    {
      aspect: 'Content Quality',
      others: 'Average',
      us: "Top-tier — you'll love it or we'll redo it",
      icon: <Award className="h-5 w-5" />
    },
    {
      aspect: 'Purpose',
      others: 'Vague',
      us: "We post to grow your business like it's our own",
      icon: <Target className="h-5 w-5" />
    },
    {
      aspect: 'Updates',
      others: 'Rare',
      us: 'Daily content & updates',
      icon: <Clock className="h-5 w-5" />
    },
    {
      aspect: 'Digital Strategy',
      others: 'Hit-or-miss',
      us: 'Custom-tailored, ongoing improvement',
      icon: <BarChart className="h-5 w-5" />
    },
    {
      aspect: 'Why Choose Them vs. Us',
      others: 'Talk more, do less',
      us: 'Talk less, do more — with real results',
      icon: <Users className="h-5 w-5" />
    },
    {
      aspect: 'Platforms Covered',
      others: 'Mostly Instagram',
      us: 'Full coverage: Instagram, TikTok, Facebook, YouTube',
      icon: <RefreshCw className="h-5 w-5" />
    },
    {
      aspect: 'DM Handling',
      others: 'Ignored',
      us: 'Active replies + care for your customers 💬❤️',
      icon: <MessageCircle className="h-5 w-5" />
    },
    {
      aspect: 'Branding',
      others: 'Often ignored',
      us: 'On-brand and consistent, every post',
      icon: <Palette className="h-5 w-5" />
    }
  ];

  return (
    <section className="py-16 bg-grow99x-lightBg">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Why We Stand Out</h2>
          <div className="h-1 w-20 bg-grow99x-orange mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* "Others" Column Header */}
          <div className="rounded-t-lg bg-gray-100 p-4 text-center">
            <h3 className="text-2xl font-bold text-gray-500">Others</h3>
          </div>
          
          {/* "Grow99X" Column Header */}
          <div className="rounded-t-lg bg-green-50 p-4 text-center shadow-md">
            <h3 className="text-2xl font-bold text-grow99x-orange">Grow99X</h3>
          </div>
          
          {/* Comparison Rows */}
          {comparisonData.map((row, index) => (
            <React.Fragment key={index}>
              {/* "Others" Card */}
              <div className="bg-white rounded-lg p-5 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="flex items-start">
                  <div className="mr-4 text-gray-400">
                    {row.icon}
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-700 mb-2">{row.aspect}</h4>
                    <div className="flex items-center">
                      <span className="text-red-500 mr-2">❌</span>
                      <p className="text-gray-500 text-sm">{row.others}</p>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* "Grow99X" Card */}
              <div className="bg-white rounded-lg p-5 shadow-md hover:shadow-lg transition-all duration-300 hover:translate-y-[-2px] border-l-4 border-[#00C853]">
                <div className="flex items-start">
                  <div className="mr-4 text-[#00C853]">
                    {row.icon}
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-700 mb-2">{row.aspect}</h4>
                    <div className="flex items-center">
                      <span className="text-[#00C853] mr-2">✅</span>
                      <p className="text-[#00C853] font-medium">{row.us}</p>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;
